@for (dot of iterableArr; track trackBy(index, dot); let index = $index) {
  <div [class.active]="active() === index" (click)="select.emit(dot)" class="dot"></div>
}
